import { Panel } from "./ui";

// Anonymous discovery counters (no typed text, IP or player link): today + last 7 days, step-by-step %.
export function Discovery({ data }) {
  if (!data) return null;
  const events = Object.keys(data.labels);
  const base = Object.fromEntries(data.ratios.map(([e, b]) => [e, b]));
  return (
    <Panel title="Discovery (anonymous)" testid="admin-discovery">
      <div className="overflow-x-auto">
        <table className="w-full text-xs mono">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500">
              <th className="py-1 pr-3 font-normal">Day (ET)</th>
              {events.map((e) => <th key={e} className="py-1 pr-3 font-normal">{data.labels[e]}</th>)}
              <th className="py-1 pr-3 font-normal">Avg wrong guesses / solve</th>
            </tr>
          </thead>
          <tbody>
            {data.days.map((d, i) => (
              <tr key={d.date} data-testid={`discovery-row-${i}`} className="border-t border-[#243144] text-slate-200">
                <td className="py-1.5 pr-3 text-slate-400">{i === 0 ? "Today" : d.date}</td>
                {events.map((e) => (
                  <td key={e} data-testid={`discovery-${i}-${e}`} className="py-1.5 pr-3">
                    {d.counts[e]}
                    {d.pct[e] != null && <span className="ml-1 text-sky-400" title={`of ${data.labels[base[e]]}`}>{d.pct[e]}%</span>}
                  </td>
                ))}
                <td data-testid={`discovery-${i}-avg-strikes`} className="py-1.5 pr-3">{d.avg_strikes ?? "–"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-[11px] text-slate-500">% = share of the previous step (hover a % to see its base). Visits count once per browser visit; cryptoquip wipes count every wipe; solves are verified by the server.</p>
    </Panel>
  );
}
